import script from "./ChatStateSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatStateSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ChatStateSwitch.vue?vue&type=style&index=0&id=539c395d&lang=scss"

const __exports__ = script;

export default __exports__